import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../node_modules/swiper/swiper.css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import "./css/Item.css";
import { fetchFichaPorId } from "../json/Datos";
import VuelveArriba from "../Componentes/vuelveArriba";
import Envio from "../Componentes/formulario/Envio";
import { Spinner } from 'react-bootstrap';

const EMAIL_DEFAULT = 'susanaespinoza.propiedades@gmail.com';
const TELEFONO_DEFAULT = '+54 9 11 3467-5725';

const ESTADO_LABEL = {
  R: 'Reservada',
  S: 'Suspendida',
  V: 'Vendida',
  A: 'Alquilada'
};

const OPERACION_LABEL = {
  ventas: 'Venta',
  alquileres: 'Alquiler'
};

const ICONOS = {
  sup: (
    <svg viewBox="0 0 24 24"><path d="M3 3h18v18H3V3zm2 2v14h14V5H5zm3 3h8v2H8V8zm0 4h5v2H8v-2z" /></svg>
  ),
  amb: (
    <svg viewBox="0 0 24 24"><path d="M3 10h18v2H3v-2zm2 4h14v6H5v-6zm2 2v2h2v-2H7zm8 0v2h2v-2h-2z" /></svg>
  ),
  bano: (
    <svg viewBox="0 0 24 24"><path d="M4 12a4 4 0 014-4h2V6a2 2 0 114 0v2h6a2 2 0 012 2v2H4v-2zm0 4h16v2a4 4 0 01-4 4H8a4 4 0 01-4-4v-2z" /></svg>
  ),
  cochera: (
    <svg viewBox="0 0 24 24"><path d="M5 11l1.5-4.5A2 2 0 018.4 5h7.2a2 2 0 011.9 1.5L19 11v7a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H8v1a1 1 0 01-1 1H6a1 1 0 01-1-1v-7zm2.5 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" /></svg>
  )
};

const Spec = ({ icono, valor, etiqueta }) => {
  if (!valor) return null;
  return (
    <div className="spec-item">
      {ICONOS[icono]}
      <strong>{valor}</strong>
      <span>{etiqueta}</span>
    </div>
  );
};

const Detalle = ({ etiqueta, valor }) => {
  if (!valor) return null;
  return (
    <div className="detalle-row">
      <span>{etiqueta}</span>
      <strong>{valor}</strong>
    </div>
  );
};

// La API manda la descripción con las oraciones pegadas, sin espacio
// ("...Federal.Avenida Cabildo..."), no con párrafos reales. Separamos por
// punto seguido de mayúscula (y no por "$30.000", que no es fin de oración).
const formatearDescripcion = (texto) => {
  if (!texto) return [];
  return texto
    .replace(/ /g, ' ')
    .split(/\.\s*(?=[A-ZÁÉÍÓÚÑ])/)
    .map((oracion) => oracion.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .map((oracion) => (oracion.endsWith('.') ? oracion : `${oracion}.`));
};

// Se usa tanto en el panel lateral (siempre visible) como adentro del modal
// que abren los botones "Quiero visitar / que me llamen / saber más" en
// desktop: cada instancia maneja su propio envío.
const FormularioContacto = ({ itemId, itemTitulo, urlActual, mensajeInicial }) => {
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setEnviando(true);
    Envio(event).then((ok) => {
      setEnviando(false);
      setEnviado(ok);
    });
  };

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <input type="hidden" name="_subject" value={`Consulta por ficha ${itemId}`} />
      <input type="hidden" name="property_operation" value={`${itemTitulo} (Código ${itemId}) - ${urlActual}`} />
      <input name="name" type="text" placeholder="Nombre" required />
      <input name="email" type="email" placeholder="E-mail" required />
      <input name="phone" type="tel" placeholder="Teléfono (sin el 15)" required />
      <textarea
        name="message"
        rows="3"
        defaultValue={mensajeInicial}
      />
      <button type="submit" className="item-btn-contactar" disabled={enviando}>
        {enviando ? 'Enviando...' : 'Enviar'}
      </button>
      {enviado === true && <p className="item-form-msg item-form-ok">¡Listo! Te vamos a contactar a la brevedad.</p>}
      {enviado === false && <p className="item-form-msg item-form-error">No pudimos enviar tu consulta. Probá de nuevo.</p>}
    </form>
  );
};

const Item = () => {
  const { fichaId } = useParams();
  const [item, setItem] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState('fotos');
  const [modalMensaje, setModalMensaje] = useState(null);

  useEffect(() => {
    let cancelado = false;
    setCargando(true);
    setError(null);

    fetchFichaPorId(fichaId)
      .then((ficha) => {
        if (cancelado) return;
        if (!ficha) {
          setError('No encontramos esta propiedad. Puede que ya no esté disponible.');
        } else {
          setItem(ficha);
          document.title = ficha.titulo;
        }
        setCargando(false);
      })
      .catch((err) => {
        console.error('Error al traer la ficha:', err);
        if (!cancelado) {
          setError('No pudimos cargar esta propiedad. Intentá de nuevo en unos minutos.');
          setCargando(false);
        }
      });

    return () => { cancelado = true; };
  }, [fichaId]);

  if (cargando) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  if (error || !item) {
    return (
      <VuelveArriba>
        <div className="item-error">
          <p>{error}</p>
          <Link to="/propiedades" className="btn btn-bordo">Ver todas las propiedades</Link>
        </div>
      </VuelveArriba>
    );
  }

  const estadoLabel = ESTADO_LABEL[item.disponibilidad] || item.estado;
  const operacionLabel = OPERACION_LABEL[item.operacion] || '';
  const urlActual = window.location.href;

  const agenteNombre = item.vendedorNombre || 'Susana Espinoza';
  const agenteTelefono = item.vendedorTelefono || TELEFONO_DEFAULT;
  const agenteEmail = item.vendedorCorreo || EMAIL_DEFAULT;
  const agenteFoto = item.vendedorFoto || '/LogoNegro.png';
  const telefonoLimpio = agenteTelefono.replace(/[^0-9+]/g, '');

  const irAlFormulario = () => {
    document.getElementById('item-formulario')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const mapaDireccion = [item.direccion_completa, item.ubicacion, item.zonaCiudad].filter(Boolean).join(', ');
  const mapaSrc = mapaDireccion
    ? `https://www.google.com/maps?q=${encodeURIComponent(mapaDireccion)}&output=embed`
    : null;

  const compartir = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlActual)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlActual)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(`${item.titulo} - ${urlActual}`)}`,
    email: `mailto:?subject=${encodeURIComponent(item.titulo)}&body=${encodeURIComponent(urlActual)}`
  };

  const hayMedidas = item.superficieTotal || item.superficieCubierta || item.superficieTerreno || item.in_sul;

  return (
    <VuelveArriba>
      <Helmet>
        <title>{`Ficha - ${item.titulo}`}</title>
        <meta name="description" content={item.metaDescripcion} />
        <meta property="og:title" content={item.titulo} />
        <meta property="og:description" content={item.metaDescripcion} />
        <meta property="og:image" content={item.imagen || "https://susanaespinoza.com.ar/favicon.ico"} />
      </Helmet>

      <div className="item-page">
        <nav className="item-breadcrumb">
          <Link to="/propiedades">{operacionLabel || 'Propiedades'}</Link>
          {item.ubicacion && <><span className="item-breadcrumb-sep">›</span><span>{item.ubicacion}</span></>}
          {item.direccion_completa && <><span className="item-breadcrumb-sep">›</span><span>{item.direccion_completa}</span></>}
          <span className="item-breadcrumb-sep">›</span>
          <span>Código <strong>{item.id}</strong></span>
        </nav>

        <div className="item-header">
          <div>
            <h1>{item.titulo}</h1>
            {item.ubicacion && <div className="item-subtitulo">{item.ubicacion}</div>}
            {item.direccion_completa && <div className="item-subtitulo">{item.direccion_completa}</div>}
          </div>

          <div className="item-header-derecha">
            <div className="item-precio-box">
              <span>{operacionLabel ? `Precio ${operacionLabel.toLowerCase()}` : 'Precio'}</span>
              <strong>{item.precio}</strong>
            </div>
            <div className="item-specs-top">
              <Spec icono="sup" valor={item.superficieTotal} etiqueta="Sup. total" />
              <Spec icono="amb" valor={item.ambientes} etiqueta="Ambientes" />
              <Spec icono="bano" valor={item.dormitorios} etiqueta="Dormitorios" />
              <Spec icono="cochera" valor={item.cocheras} etiqueta="Cocheras" />
            </div>
          </div>
        </div>

        <div className="item-layout">
          <div className="item-galeria">
            <div className="item-tabs">
              <button
                type="button"
                className={tab === 'fotos' ? 'active' : ''}
                onClick={() => setTab('fotos')}
              >
                Fotos
              </button>
              {mapaSrc && (
                <button
                  type="button"
                  className={tab === 'mapa' ? 'active' : ''}
                  onClick={() => setTab('mapa')}
                >
                  Mapa
                </button>
              )}
            </div>

            <div className="item-media">
              {tab === 'fotos' ? (
                item.galeria.length > 0 ? (
                  <Swiper modules={[Navigation]} navigation spaceBetween={1} slidesPerView={1} className="item-swiper">
                    {item.galeria.map((img, i) => (
                      <SwiperSlide key={i}>
                        <img src={img} alt={`${item.titulo} - foto ${i + 1}`} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="item-sin-foto">Sin fotos disponibles</div>
                )
              ) : (
                <iframe
                  className="item-mapa"
                  src={mapaSrc}
                  title="Ubicación de la propiedad"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              )}
              {estadoLabel && (
                <span className="item-badge-estado">{estadoLabel}</span>
              )}
            </div>

            {/* "Quiero visitar" y "Quiero que me llamen" solo se ven en
                desktop (ver CSS); en mobile ya está el botón fijo de abajo. */}
            <div className="item-botonera-top">
              <button type="button" className="solo-desktop" onClick={() => setModalMensaje('Quiero visitar esta propiedad.')}>
                Quiero visitar
              </button>
              <button type="button" className="solo-desktop" onClick={() => setModalMensaje('Quisiera que me llamen por esta propiedad.')}>
                Quiero que me llamen
              </button>
              <button type="button" onClick={() => setModalMensaje('Quiero más información sobre esta propiedad.')}>
                Quiero saber más
              </button>
            </div>

            {item.descripcion && (
              <div className="item-descripcion">
                <h2>Descripción</h2>
                {formatearDescripcion(item.descripcion).map((oracion, i) => {
                  // La firma final ("SUSANA ESPINOZA PROPIEDADES") va en
                  // itálica y color de marca, no como párrafo normal: se
                  // detecta porque está toda en mayúsculas (sin minúsculas).
                  const letras = oracion.replace(/[^a-zA-ZÁÉÍÓÚÑáéíóúñ]/g, '');
                  const esFirma = letras.length > 3 && letras === letras.toUpperCase();
                  return (
                    <p key={i} className={esFirma ? 'item-descripcion-firma' : undefined}>{oracion}</p>
                  );
                })}
              </div>
            )}

            {item.caracteristicas.length > 0 && (
              <div className="item-caracteristicas">
                <h2>Características</h2>
                <div className="item-chips">
                  {item.caracteristicas.map((c, i) => (
                    <span className="item-chip" key={i}>{c}</span>
                  ))}
                </div>
              </div>
            )}

            <div className="item-detalles">
              <h2>Detalles de la propiedad</h2>
              <div className="item-detalles-grid">
                <Detalle etiqueta="Operación" valor={operacionLabel} />
                <Detalle etiqueta="Localidad" valor={item.localidad} />
                <Detalle etiqueta="Barrio" valor={item.barrio} />
                <Detalle etiqueta="Dirección" valor={item.direccion_completa} />
                <Detalle etiqueta="Antigüedad" valor={item.antiguedad === '0' || item.antiguedad === 0 ? 'A estrenar' : (item.antiguedad ? `${item.antiguedad} años` : '')} />
                <Detalle etiqueta="Expensas" valor={item.expensas ? `$ ${item.expensas.toLocaleString('es-AR')}` : ''} />
                <Detalle etiqueta="Estado" valor={item.estado} />
                <Detalle etiqueta="Ambientes" valor={item.ambientes} />
                <Detalle etiqueta="Dormitorios" valor={item.dormitorios} />
                <Detalle etiqueta="Baños" valor={item.baños} />
                <Detalle etiqueta="Cocheras" valor={item.cocheras} />
              </div>
            </div>

            {hayMedidas && (
              <div className="item-medidas">
                <h2>Medidas</h2>
                <div className="item-detalles-grid">
                  <Detalle etiqueta="Sup. total" valor={item.superficieTotal && `${item.superficieTotal} m²`} />
                  <Detalle etiqueta="Sup. cubierta" valor={item.superficieCubierta && `${item.superficieCubierta} m²`} />
                  <Detalle etiqueta="Sup. libre" valor={item.in_sul && `${item.in_sul} m²`} />
                  <Detalle etiqueta="Sup. terreno" valor={item.superficieTerreno && `${item.superficieTerreno} m²`} />
                </div>
                <p className="item-medidas-nota">Las superficies y medidas son aproximadas y a solo efecto orientativo.</p>
              </div>
            )}
          </div>

          <aside id="item-formulario" className="item-panel">
            <h2 className="item-panel-titulo">Contactá al asesor inmobiliario</h2>

            <div className="item-agente">
              <img src={agenteFoto} alt={agenteNombre} />
              <div>
                <strong>{agenteNombre}</strong>
                <span>{agenteEmail}</span>
                <span>{agenteTelefono}</span>
              </div>
            </div>

            <FormularioContacto
              itemId={item.id}
              itemTitulo={item.titulo}
              urlActual={urlActual}
              mensajeInicial="Vi esta propiedad y me gustaría que me contacten..."
            />

            <div className="item-compartir">
              <h3>Compartir</h3>
              <div className="item-compartir-iconos">
                <a href={compartir.facebook} target="_blank" rel="noopener noreferrer" aria-label="Compartir en Facebook" className="compartir-ico compartir-fb">
                  <svg viewBox="0 0 24 24"><path d="M22 12a10 10 0 10-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0022 12z" /></svg>
                </a>
                <a href={compartir.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Compartir en LinkedIn" className="compartir-ico compartir-li">
                  <svg viewBox="0 0 24 24"><path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.38-1.85 3.61 0 4.27 2.38 4.27 5.47v6.27zM5.34 7.43a2.07 2.07 0 110-4.13 2.07 2.07 0 010 4.13zM7.12 20.45H3.56V9h3.56v11.45z" /></svg>
                </a>
                <a href={compartir.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Compartir por WhatsApp" className="compartir-ico compartir-wsp">
                  <svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 00-8.6 15.06L2 22l5.1-1.34A10 10 0 1012 2zm0 18.15a8.1 8.1 0 01-4.14-1.13l-.3-.18-3.03.8.81-2.96-.2-.3A8.14 8.14 0 1112 20.15zm4.48-6.12c-.25-.12-1.46-.72-1.68-.8-.23-.08-.39-.12-.56.12-.17.25-.64.8-.79.96-.14.17-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.06s.88 2.4 1 2.56c.12.17 1.74 2.65 4.22 3.72.59.25 1.05.4 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.66-1.18.21-.58.21-1.08.14-1.18-.06-.1-.23-.16-.48-.28z" /></svg>
                </a>
                <a href={compartir.email} aria-label="Compartir por email" className="compartir-ico compartir-mail">
                  <svg viewBox="0 0 24 24"><path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm0 2v.01L12 13l8-6.99V6H4zm16 2.24l-7.4 6.47a1 1 0 01-1.2 0L4 8.24V18h16V8.24z" /></svg>
                </a>
              </div>
            </div>
          </aside>
        </div>

        <div className="item-botonera">
          <a href={`tel:${telefonoLimpio}`} className="item-botonera-llamar">
            Llamar
          </a>
          <button type="button" className="item-botonera-contactar" onClick={irAlFormulario}>
            Contactar
          </button>
        </div>
      </div>

      {modalMensaje !== null && (
        <div className="item-modal-overlay" onClick={() => setModalMensaje(null)}>
          <div className="item-modal" onClick={(e) => e.stopPropagation()}>
            <div className="item-modal-header">
              <span>Contactá a la inmobiliaria</span>
              <button type="button" className="item-modal-cerrar" onClick={() => setModalMensaje(null)} aria-label="Cerrar">×</button>
            </div>
            <div className="item-agente">
              <img src={agenteFoto} alt={agenteNombre} />
              <div>
                <strong>{agenteNombre}</strong>
                <span>{agenteEmail}</span>
                <span>{agenteTelefono}</span>
              </div>
            </div>
            <FormularioContacto
              itemId={item.id}
              itemTitulo={item.titulo}
              urlActual={urlActual}
              mensajeInicial={modalMensaje}
            />
          </div>
        </div>
      )}
    </VuelveArriba>
  );
};

export default Item;
